module.exports = __webpack_public_path__ + "static/media/papertrail-logo-white.4f8250e1.svg";